<template>
    <div
        class="footer"
        :style="{
            marginTop:
                route.name != 'proHome' &&
                route.name != 'modelIndex' &&
                route.name != 'murataIndex'
                    ? '88px'
                    : '',
        }"
    >
        <div class="remarkWrap">
            <div class="remark">
                <div class="remark-box">
                    <div class="remark-title">我们提供</div>
                    <!-- @click="allCategories" -->
                    <a
                        class="remark-inner"
                        href="/search.html"
                        title="allCategories"
                    >
                        元器件采购
                    </a>
                    <a class="remark-inner" @click="goService">定制服务</a>
                </div>
                <div class="remark-box">
                    <div class="remark-title">购物指南</div>
                    <a
                        class="remark-inner"
                        :href="'/news/' + '2533660415887474688' + '.html'"
                        :title="'/news/' + '2533660415887474688' + '.html'"
                    >
                        购物流程
                    </a>
                    <a
                        class="remark-inner"
                        :href="'/news/' + '2534638343165116416' + '.html'"
                        :title="'/news/' + '2534638343165116416' + '.html'"
                    >
                        退换货说明
                    </a>
                    <a
                        class="remark-inner"
                        :href="'/news/' + '2534635326219026432' + '.html'"
                        :title="'/news/' + '2534635326219026432' + '.html'"
                    >
                        发票须知
                    </a>
                </div>
                <div class="remark-box">
                    <div class="remark-title">配送方式</div>
                    <a
                        class="remark-inner"
                        :href="'/news/' + '2534688862449500160' + '.html'"
                        :title="'/news/' + '2534688862449500160' + '.html'"
                    >
                        配送说明
                    </a>
                    <a
                        class="remark-inner"
                        :href="'/news/' + '2534637516652347392' + '.html'"
                        :title="'/news/' + '2534637516652347392' + '.html'"
                    >
                        运费收取标准
                    </a>
                    <a
                        class="remark-inner"
                        :href="'/news/' + '2535781654600941568' + '.html'"
                        :title="'/news/' + '2535781654600941568' + '.html'"
                    >
                        联系我们
                    </a>
                </div>
                <div class="remark-box">
                    <div class="remark-title">我的账户</div>
                    <div class="remark-inner" @click="goOrder" v-isLoginClickCheck>
                        我的订单
                    </div>
                    <div class="remark-inner" @click="goShop" v-isLoginClickCheck>
                        我的购物车
                    </div>
                    <a
                        class="remark-inner"
                        :href="'/news/' + '2534625054536302592' + '.html'"
                        :title="'/news/' + '2534625054536302592' + '.html'"
                    >
                        常见问题
                    </a>
                </div>
                <div class="remark-box remark-box-inner">
                    <div class="remark-title">服务热线</div>
                    <div class="remark-inner-span remark-inner-span-1">
                        400-860-3536
                    </div>
                    <div class="remark-inner-span-title">服务时间:</div>
                    <div class="remark-inner-span">工作日 9:00-17:30</div>
                    <!-- <div class="remark-inner-span">9:00-17:00(节假日)</div> -->
                </div>
                <div class="remark-box remark-box-inner" style="margin-right: 0; text-align: left; width: 80px;">
                    <img
                        class="footer_logo"
                        src="@/assets/images/ProHome/footer_logo.png"
                        alt="感算LOGO"
                        style="display: block;"
                    />
                    <img
                        src="@/assets/images/ProHome/qrcode_footer.jpg"
                        alt="感算公众号"
                        class="qrcode"
                    />
                    <p class="remark-box-public">感算公众号</p>
                </div>
                <div class="remark-box remark-box-inner" style="padding-top: 26px; width: auto;">
                    <img
                        src="@/assets/images/ProHome/shop.png"
                        alt="感算微商城"
                        class="qrcode"
                    />
                    <p class="remark-box-public">感算微商城</p>
                </div>
            </div>
        </div>
        <div class="alphabetIndexWrap">
            <div class="alphabet-index">
            <h2>字母索引</h2>
                <a href="https://www.gansuan.com/alphabeticIndex/A_1.html">A</a>
                <a href="https://www.gansuan.com/alphabeticIndex/B_1.html">B</a>
                <a href="https://www.gansuan.com/alphabeticIndex/C_1.html">C</a>
                <a href="https://www.gansuan.com/alphabeticIndex/D_1.html">D</a>
                <a href="https://www.gansuan.com/alphabeticIndex/E_1.html">E</a>
                <a href="https://www.gansuan.com/alphabeticIndex/F_1.html">F</a>
                <a href="https://www.gansuan.com/alphabeticIndex/G_1.html">G</a>
                <a href="https://www.gansuan.com/alphabeticIndex/H_1.html">H</a>
                <a href="https://www.gansuan.com/alphabeticIndex/I_1.html">I</a>
                <a href="https://www.gansuan.com/alphabeticIndex/J_1.html">J</a>
                <a href="https://www.gansuan.com/alphabeticIndex/K_1.html">K</a>
                <a href="https://www.gansuan.com/alphabeticIndex/L_1.html">L</a>
                <a href="https://www.gansuan.com/alphabeticIndex/M_1.html">M</a>
                <a href="https://www.gansuan.com/alphabeticIndex/N_1.html">N</a>
                <a href="https://www.gansuan.com/alphabeticIndex/O_1.html">O</a>
                <a href="https://www.gansuan.com/alphabeticIndex/P_1.html">P</a>
                <a href="https://www.gansuan.com/alphabeticIndex/Q_1.html">Q</a>
                <a href="https://www.gansuan.com/alphabeticIndex/R_1.html">R</a>
                <a href="https://www.gansuan.com/alphabeticIndex/S_1.html">S</a>
                <a href="https://www.gansuan.com/alphabeticIndex/T_1.html">T</a>
                <a href="https://www.gansuan.com/alphabeticIndex/U_1.html">U</a>
                <a href="https://www.gansuan.com/alphabeticIndex/V_1.html">V</a>
                <a href="https://www.gansuan.com/alphabeticIndex/W_1.html">W</a>
                <a href="https://www.gansuan.com/alphabeticIndex/X_1.html">X</a>
                <a href="https://www.gansuan.com/alphabeticIndex/Y_1.html">Y</a>
                <a href="https://www.gansuan.com/alphabeticIndex/Z_1.html">Z</a>
                <a href="https://www.gansuan.com/alphabeticIndex/0_1.html">0</a>
                <a href="https://www.gansuan.com/alphabeticIndex/1_1.html">1</a>
                <a href="https://www.gansuan.com/alphabeticIndex/2_1.html">2</a>
                <a href="https://www.gansuan.com/alphabeticIndex/3_1.html">3</a>
                <a href="https://www.gansuan.com/alphabeticIndex/4_1.html">4</a>
                <a href="https://www.gansuan.com/alphabeticIndex/5_1.html">5</a>
                <a href="https://www.gansuan.com/alphabeticIndex/6_1.html">6</a>
                <a href="https://www.gansuan.com/alphabeticIndex/7_1.html">7</a>
                <a href="https://www.gansuan.com/alphabeticIndex/8_1.html">8</a>
                <a href="https://www.gansuan.com/alphabeticIndex/9_1.html">9</a>
                <a href="https://www.gansuan.com/alphabeticIndex/其他_1.html">其它</a>
            </div>
        </div>
        <div class="friendlyLink" v-if="false">
            <div
                :class="
                    linkshow
                        ? 'friendlyLink-box friendlyLink-box-show'
                        : 'friendlyLink-box'
                "
            >
                <div class="friendlyLink-title friendlyLink-box_content">友情链接</div>
                <div
                    class="friendlyLink-box_content"
                    v-for="item in showLinkData"
                    :key="item.id"
                    @click="looklink(item.linkUrl)"
                >
                    {{ item.keyword }}
                </div>
                <img
                    src="../../assets/images/Home/off.svg"
                    alt=""
                    v-if="!linkshow && showLinkData.length > 26"
                    @click="linkshow = true"
                    class="link-off"
                />
                <img
                    src="../../assets/images/Home/open.svg"
                    v-if="linkshow && showLinkData.length > 26"
                    @click="linkshow = false"
                    class="link-show"
                />
            </div>
        </div>
        <div class="company" :style="
                showLinkData.length <= 0
                    ? ' padding-top: 12px;'
                    : ''
            ">
            <p>@2021-2025 上海感算电子科技有限公司 版权所有</p>
            <a href="https://beian.miit.gov.cn" target="_blank"
                >沪ICP备2021016815号-3</a
            >
            <p @click="getPrivateApi(1)" style="cursor: pointer">服务协议</p>
            <p @click="getPrivateApi(2)" style="cursor: pointer">隐私政策</p>
            <a
                target="_blank"
                href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010502006803"
            >
                <img src="@/assets/images/ProHome/beian.png" alt="公网安备图" />
                沪公网安备 31010502006803号</a
            >
            <a
                href="https://wap.scjgj.sh.gov.cn/businessCheck/verifKey.do?showType=extShow&serial=9031000020230315110956000010218886-SAIC_SHOW_310000-20230621164604396851&signData=MEUCICEIlChnlj05CErx6w9gEN8LglCrU2qJ3r/fjnbQjXFJAiEAxK5bkLTVpR3SLzCLu4eGFLj5el0rr8DRfMGSXqaRG9U="
                target="_blank"
            >
                <img
                    src="@/assets/images/ProHome/supervisor.png"
                    alt="工商网监"
                />
                工商网监
            </a>
            <p @click="gositemap" style="cursor: pointer">网站地图</p>
        </div>
    </div>
    <ZDialog
        :dialog-object="dialogObjDelDef"
        @dialogClose="dialogCloseDef"
        class="private-dialog"
    >
        <div v-html="private" class="private"></div>
    </ZDialog>
</template>
<script lang="ts">
import {
    reactive,
    toRefs,
    defineComponent,
    watch,
    onMounted,
    onBeforeMount,
} from 'vue';
import ZDialog from '@/components/ZDialog.vue';
import { useUserStore } from '@/store/User';
import { useRouter, useRoute } from 'vue-router';
import API from '@/api';
import { contentIndex } from '@/api/PcModule/home';
import { deleteHtml, openUrl } from '@/utils/common';
export default defineComponent({
    name: 'Footer',
    components: {
        ZDialog,
    },
    setup() {
        const store = useUserStore();
        let router = useRouter();
        let route = useRoute();
        const data = reactive({
            private: '',
            FriendLinkData: [],
            showLinkData: [],
            linkshow: false,
            urlname: '',
        });
        const refData = toRefs(data);
        const goOrder = () => {
            router.push({
                name: 'mineOrder',
            });
        };
        // 去购物车
        const goShop = () => {
            // const newPage = router.resolve({
            //     name: 'shop',
            // });
            // window.open(import.meta.env.VITE_WWW_HOST);
            router.push({
                name: 'shop',
            });
        };

        const dialogObjDelDef = reactive({
            dialogVisible: false,
            title: refData.private.value.title,
            width: '916px',
            // successBtnText: '保存',
            // closeBtnText: '取消',
            isFooter: false, // 是否显示按钮
        });
        // 关闭弹窗
        const dialogCloseDef = () => {
            dialogObjDelDef.dialogVisible = false;
        };
        const getPrivateApi = async (num) => {
            let newArr = store.private.filter((item) => {
                return item.num == num;
            });
            if (newArr.length === 0) {
                store.getPrivateApi(num);
                setTimeout(() => {
                    dialogObjDelDef.dialogVisible = true;
                    dialogObjDelDef.title =
                        store.private[store.private.length - 1].title;
                    refData.private.value =
                        store.private[store.private.length - 1].content;
                }, 300);
            } else {
                dialogObjDelDef.dialogVisible = true;
                dialogObjDelDef.title = newArr[0].title;
                refData.private.value = newArr[0].content;
            }
        };
        const allCategories = () => {
            // const newPage = router.resolve({
            //     name: 'allCategories',
            // });
            // window.open(import.meta.env.VITE_WWW_HOST);

            router.push({
                name: 'allCategories',
            });
        };
        const goService = () => {
            router.push({
                name: 'module',
            });
        };
        onBeforeMount(() => {
            if (
                route.name !== 'proHome' &&
                store.contentData.pubs === undefined
            ) {
                getContent();
            }
        });
        // 内容
        const getContent = async () => {
            let data = await contentIndex();
            if (data.code === 200) {
                store.contentData = data.data || [];
            }
        };
        const showCustomer = () => {
            if (store.userInfo.id) {
                const newPage = router.resolve({
                    name: 'customer',
                });
                window.open(newPage.href);
            }
        };
        const readContentAction = async (index: number) => {
            let id = store.contentData.pubs[index].id;
            let data = API.readContent({
                contentId: id,
            });
            // if (id) {
            //     const newPage = router.resolve({
            //         name: 'content',
            //         params: {
            //             id,
            //         },
            //     });
            //     openUrl(newPage.href + '.html');
            // }
        };

        const looklink = (url) => {
            window.open(url, '_blank');
        };

        onMounted(() => {});

        watch(
            () => route.name,
            async (newPath, oldPath) => {
                refData.showLinkData.value = [];
                let res = await API.getLink();
                if (res.code === 200) {
                    refData.FriendLinkData.value = res.data || [];
                }
                console.log(newPath, oldPath, 11111);
                if (newPath === 'proHome') {
                    refData.urlname.value = '首页';
                } else if (newPath === 'Modellist') {
                    refData.urlname.value = '方案定制';
                } else if (newPath === 'customization') {
                    refData.urlname.value = '传感器定制';
                } else if (newPath === 'Information') {
                    refData.urlname.value = '资讯列表';
                } else if (newPath === 'modelIndex') {
                    refData.urlname.value = '模块专区';
                } else if (newPath === 'customizationDetail') {
                    refData.urlname.value = '传感器定制详情';
                } else if (newPath === 'content') {
                    let contentDetails = {};
                    let typeData = [
                        {
                            type: 2,
                            title: '方案定制详情',
                        },
                        {
                            type: 3,
                            title: '资讯列表详情',
                        },
                        {
                            type: 6,
                            title: '模块专区详情',
                        },
                    ];
                    let data = await API.getContentDetail({
                        contentId: deleteHtml(route.params.id as string),
                    });
                    if (data.code == 200) {
                        contentDetails = data.data || {};
                        typeData.map((e) => {
                            if (e.type === contentDetails.type) {
                                refData.urlname.value = e.title;
                            }
                        });
                    }
                } else {
                    refData.urlname.value = '其他';
                }
                console.log(
                    refData.urlname.value,
                    refData.FriendLinkData.value,
                    2334554,
                );
                refData.FriendLinkData.value.map((item) => {
                    let findIndex = item.linkPagesDesc.findIndex(
                        (info) => info.dictLabel === refData.urlname.value,
                    );
                    if (findIndex > -1) {
                        refData.showLinkData.value.push(item);
                    }
                });
            },
            { immediate: true },
        );
        const gositemap = () => {
            location.href = import.meta.env.VITE_SEO_HOST + '/sitemap.html';
        };
        return {
            ...refData,
            goOrder,
            goShop,
            dialogObjDelDef,
            getPrivateApi,
            dialogCloseDef,
            allCategories,
            goService,
            readContentAction,
            showCustomer,
            looklink,
            route,
            store,
            gositemap,
        };
    },
});
</script>
<style scoped lang="scss">
.footer {
    min-height: 271px;
    padding-top: 24px;
    box-sizing: border-box;
    // margin-top: 88px;
    width: 100%;
    min-width: $inner-width;

    .remarkWrap {
        background: #004f9a;
        position: relative;
        padding-top: 30px;
        overflow: hidden;

        .remark {
            width: 1200px;
            margin: 0 auto;
            display: flex;
            padding-bottom: 30px;

            .remark-box {
                margin-right: 144px;

                .remark-title {
                    display: block;
                    margin-bottom: 24px;
                    font-weight: 600;
                    font-size: 14px;
                    line-height: 140%;
                    color: #fff;
                    display: block;
                }

                .remark-inner {
                    display: block;
                    cursor: pointer;
                    margin-bottom: 11px;
                    font-size: 12px;
                    line-height: 140%;
                    color: #fff;
                }

                .remark-inner-span {
                    margin-bottom: 6px;
                    font-size: 12px;
                    line-height: 17px;
                    color: #fff;
                }

                .remark-inner-span:last-of-type {
                    margin-bottom: 0;
                }

                .remark-inner-span-1 {
                    margin-bottom: 19px;
                }

                .remark-inner-span-title {
                    font-size: 14px;
                    line-height: 140%;
                    color: #ffffff;
                    margin-bottom: 3px;
                }

                .footer_logo {
                    height: 26px;
                    width: 112px;
                }

                .qrcode {
                    height: 64px;
                    width: 64px;
                    margin-top: 20px;
                    margin-bottom: 12px;
                }

                .remark-box-public {
                    color: #fff;
                }

                .remark-inner:hover {
                    color: #fff;
                }
            }

            .remark-box-inner {
                margin-right: 114px;

                .remark-title {
                    margin-bottom: 6px;
                }
            }

            .remark-box:last-of-type {
                width: 114px;
                margin-right: 0 !important;
            }

            .remark-box:last-of-type {
                text-align: center;
                margin-left: 0;
                margin-right: 34px;
            }
        }
    }

    .friendlyLink {
        width: 1220px;
        margin: 0 auto;
        padding-left: 20px;
        color: #333;

        .friendlyLink-title {
            font-weight: 600;
            font-size: 14px;
        }

        .friendlyLink-box {
            display: flex;
            flex-wrap: wrap;
            box-sizing: border-box;
            max-height: 54px;
            overflow: hidden;
            box-sizing: border-box;
            position: relative;
            padding-top: 12px;

            .friendlyLink-box_content {
                font-size: 13px;
                margin-right: 20px;
                margin-bottom: 12px;
                cursor: pointer;
            }

            .link-off,
            .link-show {
                width: 12px;
                height: 12px;
                margin-top: 13px;
            }

            .link-off {
                margin-top: 0;
                position: absolute;
                bottom: 0px;
                right: 10px;
            }
        }

        .friendlyLink-box-show {
            height: auto;
            max-height: none;
        }
    }

    .company {
        display: flex;
        width: 1200px;
        margin: 0 auto;
        align-items: center;
        padding-bottom: 12px;
        padding-top: 4px;

        a {
            font-size: 12px;
            color: #333;
            font-size: 12px;
            line-height: 140%;
            display: flex;
            align-items: center;

            img {
                width: 16px;
                height: 16px;
                margin-right: 8px;
            }
        }

        p {
            font-size: 12px;
            color: #333;
            font-size: 12px;
            line-height: 140%;
        }

        & a::after,p::after {
            content: '';
            width: 1px;
            height: 10px;
            margin: 0 16px;
            background: #333;
            display: inline-block;
            vertical-align: inherit;
        }
    }

    .company p:last-child::after {
        display: none;
    }
}

.alphabetIndexWrap {
    background: #004f9a;

    .alphabet-index {
        width: 1200px;
        border-top: 1px solid #989898;
        margin: 0 auto;
        height: 50px;
        display: flex;
        align-items: center;
        white-space: nowrap;
        color: #fff;

        h2 {
            font-size: 14px;
            display: inline-block;
        }

        a {
            color: #fff;
            font-size: 13px;
            margin-left: 22px;
        }
    }
}
</style>
<style lang="scss">
.customer-wx {
    padding: 8px 4px 0 !important;
    text-align: center !important;
    width: 120px !important;
    min-width: 120px !important;

    .customer-wx-p {
        color: #333;
        text-align: center;
        font-size: 12px;
        font-family: 思源黑体 CN;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
    }

    .customer-tip {
        width: 91px;
        height: 91px;
    }
}
</style>
